module.exports = __webpack_public_path__ + "static/media/image_partners_3.e93fbf1b.png";